export default "__VITE_ASSET__DBa7NJeF__"